import { FC } from 'react';

import { useEmployeeQuery as useQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { useFetchQuestionGroups } from '@jbc-year-end-adj/2024/features/questions/hooks/employee/useFetchQuestionGroups';
import { LoadingPage } from '../../Loading';
import { Form } from './Form';
import { QueryResult, FETCH_INSURANCE_STATUSES } from './query';

type HasInsurancesProps = {
  question: Question;
};

export const HasInsurances: FC<HasInsurancesProps> = ({ question }) => {
  const { data, loading } = useFetchQuestionGroups();
  const { data: insuranceStatusData, loading: insuranceStatusLoading } = useQuery<QueryResult>(FETCH_INSURANCE_STATUSES);
  if (loading || insuranceStatusLoading) return <LoadingPage />;
  if (!data || !insuranceStatusData) throw Error;

  return <Form question={question} questionGroups={data.questionGroups} profile={insuranceStatusData.request.profile} />;
};
